import React from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonGroup,
  Button,
  ButtonDropdown
} from "reactstrap";
import { FeedbackCategory } from "../../../Constants/feedbackEnums";
import { QueryReportType } from "../../../Constants/QueryReportType";

type Props = {
  options: { queryType: QueryReportType; category: FeedbackCategory }[];
  value: string;
  onSelect: (selected: QueryReportType) => void;
};

type State = {
  isOpen: boolean;
};

export class FeedbackCategoryDropdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  onToggle = () => this.setState(prevState => ({ isOpen: !prevState.isOpen }));

  render() {
    const styles: React.CSSProperties = {
      backgroundColor: "white",
      color: "black",
      opacity: "initial"
    };

    return (
      <ButtonGroup>
        <Button disabled style={styles}>
          Report Type
        </Button>
        <ButtonDropdown isOpen={this.state.isOpen} toggle={this.onToggle}>
          <DropdownToggle caret>
            {this.props.value === QueryReportType.Feature && "Feature Request"}
            {this.props.value === QueryReportType.Bug && "Bug Report"}
            {this.props.value === QueryReportType.ResourceRequest && "Resource Request"}
          </DropdownToggle>
          <DropdownMenu>
            {this.props.options.map(option => (
              <DropdownItem
                key={option.category}
                onClick={() => this.props.onSelect(option.queryType)}
              >
                {option.category}
              </DropdownItem>
            ))}
            {/* <DropdownItem onClick={() => this.props.onSelect(QueryReportType.Feature)}>Feature Request</DropdownItem>
            <DropdownItem onClick={() => this.props.onSelect(QueryReportType.Bug)}>Bug Report</DropdownItem> */}
          </DropdownMenu>
        </ButtonDropdown>
      </ButtonGroup>
    );
  }
}
